import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const loadStateFromStorage = () => {
  return {
    reviews: {
      products: []
    },
    loading: false,
    error: null,
  };
};

const initialState = loadStateFromStorage();

const reviewSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {
    setReviews: (state, action) => {
      // console.log('Setting reviews with payload:', action.payload);
      state.reviews.products = action.payload || [];
    },
    addReview: (state, action) => {
      state.reviews.products.unshift(action.payload);
    },
    removeReview: (state, action) => {
      const reviewId = action.payload;
      state.reviews.products = state.reviews.products.filter(
        (review) => review._id !== reviewId
      );
    },
  },
});

export const { addReview, setReviews, removeReview } = reviewSlice.actions;

// Add review
export const addReviewApi = (productId, rating, comment) => async (dispatch) => {
  const userLogin = localStorage.getItem("user");
  if (!userLogin) {
    toast.error("Please log in to add a review");
    return;
  }

  try {
    const user = JSON.parse(userLogin);
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/reviews`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ 
        productId, 
        rating,
        description: comment,
        userId: user.id,
        title: "",
        reviewImages: []
      }),
    });
    const data = await response.json();
    const { success, message, responseObject } = data;
    
    if (success) {
      dispatch(addReview(responseObject));
      dispatch(fetchReviews(productId));
      toast.success(message);
    } else {
      toast.error(message || "Failed to add review");
    }
  } catch (error) {
    console.error("Add review error:", error);
    toast.error("Failed to add review");
  }
};

// Fetch reviews
export const fetchReviews = (productId) => async (dispatch) => {
  try {
    // console.log('Fetching reviews for product ID:', productId);
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/reviews/product/${productId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    // console.log('API Response:', data);
    
    if (data.success) {
      dispatch(setReviews(data.responseObject));
    } else {
      toast.error(data.message || "Failed to fetch reviews");
    }
  } catch (error) {
    console.error("Fetch reviews error:", error);
    toast.error("Failed to fetch reviews");
  }
};

// Delete review
export const deleteReview = (reviewId, productId) => async (dispatch) => {
  const userLogin = localStorage.getItem("user");
  if (!userLogin) {
    toast.error("Please log in to delete review");
    return;
  }

  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/reviews/${reviewId}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    const { success, message } = await response.json();
    if (success) {
      dispatch(removeReview(reviewId));
      dispatch(fetchReviews(productId)); // Refresh reviews after deletion
      toast.success(message);
    } else {
      toast.error(message || "Failed to delete review");
    }
  } catch (error) {
    console.error("Delete review error:", error);
    toast.error("Failed to delete review");
  }
};

export default reviewSlice.reducer; 